import { z } from "zod";
import { zUid } from "./zUid";

export const zUserInfo = z.object({
  // position: z.string(),
  id: zUid,
  firstName: z.string(),
  secondName: z.string(),
  userName: z.string(), //  "a.kirillov@omnidata.ru"
  roleId: zUid,
  refreshToken: z.string(),
});

export type ZUserInfo = z.infer<typeof zUserInfo>;
